import React from "react";
import styled from "styled-components";
import {
  Color,
  FontFamily,
  FontWeight,
  background,
  border,
  content,
  transparentize,
} from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Icon from "@ui-kit/icon";
import ResetButton from "@radarly/components/filterbar/gigantic-button";
import { tr } from "@radarly/i18n";

interface IProps {
  locale: Locale;
  onReset: () => void;
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${content};
  background-color: ${background};
  border-top: 1px solid ${(props) => content(props, "tertiary")};
  height: 71px;
  box-shadow: ${transparentize(0.8, Color.Black)} 0 1px 2px 0;
  position: initial;
  width: 100%;
`;

const Warning = styled.div`
  display: flex;
  align-items: center;
  padding-left: 32px;
`;

const Title = styled.h1`
  margin-left: 16px;
  font-family: ${FontFamily.Sans};
  font-weight: ${FontWeight.Bold};
`;

const StyledResetButton = styled(ResetButton)`
  border-left: 1px solid ${border};
`;

export default function ErrorFilterbarLayout({ locale, onReset }: IProps) {
  return (
    <Root>
      <Warning>
        <Icon glyph="circle-bang" size={24} />
        <Title>{tr(locale, "INSIGHT-PAGES::ERROR-DELETED-FIELDS")}</Title>
      </Warning>
      <StyledResetButton glyph="round-arrow-cross" onClick={onReset} />
    </Root>
  );
}
